import { whiteSpaceValidator } from "@libs/extended-forms/custom-validators/white-space.validator";
import { Validators } from "angular-reactive-validation";

export const ChangePasswordValidator = {
    oldPassword: [
        Validators.required('password is required'),
        whiteSpaceValidator(`Spaces are not allowed`),
        Validators.minLength(8, minLength => `Minimum length is ${minLength}`),
        Validators.maxLength(30, maxLength => `Maximum length is ${maxLength}`),
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$', 'Password should contain (Lowercase letters, Uppercase letters, Numbers, Special characters)'),
        Validators.pattern('^(?=.*?[^a-zA-Z0-9]).{1,}$', 'Password should contain (Lowercase letters, Uppercase letters, Numbers, Special characters)')
    ],
    newPassword: [
        Validators.required('password is required'),
        whiteSpaceValidator(`Spaces are not allowed`),
        Validators.minLength(8, minLength => `Minimum length is ${minLength}`),
        Validators.maxLength(30, maxLength => `Maximum length is ${maxLength}`),
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$', 'Password should contain (Lowercase letters, Uppercase letters, Numbers, Special characters)'),
        Validators.pattern('^(?=.*?[^a-zA-Z0-9]).{1,}$', 'Password should contain (Lowercase letters, Uppercase letters, Numbers, Special characters)')
    ],
    confirmPassword: [
        Validators.required('Password confirmation is required'),
        whiteSpaceValidator(`Spaces are not allowed`),
        Validators.minLength(8, minLength => `Minimum length is ${minLength}`),
        Validators.maxLength(30, maxLength => `Maximum length is ${maxLength}`),
        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{6,}$', 'Password should contain (Lowercase letters, Uppercase letters, Numbers, Special characters)'),
        Validators.pattern('^(?=.*?[^a-zA-Z0-9]).{1,}$', 'Password should contain (Lowercase letters, Uppercase letters, Numbers, Special characters)')
    ],
};